export default __webpack_public_path__ + "static/media/CSV.20bd3469.svg";